<template>
  <div class="background-modal">
    <div class="wrapper-modal">
      <p class="text">
        {{ message }}
      </p>
      <div class="wrapper-buttons">
        <StandardButton
          :buttonLabel="'No, cancelar'"
          @click="closeModal"
          :isCancel="true"
          class="full"
        />
        <StandardButton
          :buttonLabel="'Sí, anular'"
          @click="reasonCancellation"
          class="full"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import StandardButton from "@/components/commons/controls/StandardButton.vue";

export default defineComponent({
  name: "ModalConfirmationCancellation",
  components: {
    StandardButton,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    function closeModal() {
      context.emit("closeConfirmCancellation");
    }

    function reasonCancellation() {
      context.emit("openReasonCancellationModal");
    }

    return {
      closeModal,
      reasonCancellation,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/sharedComponents/styles/modalConfirmCancellationStyle";
</style>
